<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 lg8 offset-lg2>
        <v-layout row wrap align-center>
          <v-flex xs12 class="pa-2">
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>


              <!-- Spring -->
                      <!-- <mainHeader
                        title="Spring Taekwon-Do Session"
                        subtitle="10 week session starts 3/23"
                        class="mb-4">
                      </mainHeader>

                      <v-flex xs12>
                        <v-img
                          height="300px"
                          contain
                          :src="require('../assets/Front.jpg')"
                        ></v-img>
                      </v-flex>
                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center mb-5">
                        <v-layout row wrap>
                            <v-flex xs12 sm4 pa-1>
                              <h2><u>Mondays</u><v-icon color="red" >mdi-star</v-icon></h2>
                              <h3>TKD 1: 4:00</h3>
                              <h3>TKD 2: 5:00</h3>
                              <h3>TKD 3 & Black Belt: 6:00</h3>
                              <h4>March 23rd - June 3rd</h4>
                              <h4>No class 4/20 and 5/25</h4>

                              <v-btn color="primary" to="/signup/mon2">Signup</v-btn>
                            </v-flex>
                            <v-flex xs12 sm4 pa-1>
                              <h2><u>Wednesdays</u><v-icon color="red" >mdi-star</v-icon></h2>
                              <h3>TKD 1: 4:00</h3>
                              <h3>TKD 2: 5:00</h3>
                              <h3>TKD 3: 6:00</h3>
                              <h4>March 25th - June 3rd</h4>
                              <h4>No class 4/22</h4>
                              <v-btn :disabled="false" color="primary" to="/signup/wed2">Signup</v-btn>
                            </v-flex>
                            <v-flex xs12 sm4 pa-1>
                              <h2><u>Thursdays</u><v-icon color="red" >mdi-star</v-icon></h2>
                              <h3>TKD 1 & 2: 5:00</h3>
                              <h3>TKD 3: 6:00</h3>
                              <h3 style="opacity:0.0">TKD</h3>
                              <h4>March 26th - June 4th</h4>
                              <h4>No class 4/23</h4>

                              <v-btn color="primary" to="/signup/thur2">Signup</v-btn>
                            </v-flex>
                        </v-layout>

                        <h3 class="mt-3">$325 for the 10 week session. Payment due at time of registration. </h3>
                        <h3><v-icon color="red" >mdi-star</v-icon>New Location! All Classes will be held at TILT Crossfit 60 Union Ave. Sudbury</h3>
                        <h3><a href="https://maps.app.goo.gl/VzKbDnBTE7H9QAR69">Directions</a></h3>
                      </v-flex>
 -->



            <!-- WINTER -->
                    <!-- <mainHeader
                      title="Winter Taekwon-Do Session"
                      subtitle="10 week session starts 12/8"
                      class="mb-4">
                    </mainHeader>

                    <v-flex xs12>
                      <v-img
                        height="300px"
                        contain
                        :src="require('../assets/Main.jpg')"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 sm10 offset-sm1 class="text-xs-center mb-5">
                      <v-layout row wrap>
                            <v-flex xs12 sm4 pa-1>
                              <h2><u>Mondays</u><v-icon color="red" >mdi-star</v-icon></h2>
                              <h3>TKD 1: 4:00</h3>
                              <h3>TKD 2: 5:00</h3>
                              <h3>TKD 3 & Black Belt: 6:00</h3>
                              <h4>Dec. 8th - March 10th</h4>
                              <h4 class="red">No Class 12/22,12/29,1/19,2/16</h4>
                              <h4>Class ends 3/9</h4>
                              <v-btn color="primary" to="/signup/mon">Signup</v-btn>
                            </v-flex>
                            <v-flex xs12 sm4 pa-1>
                              <h2><u>Wednesdays</u><v-icon color="red" >mdi-star</v-icon></h2>
                              <h3>TKD 1: 4:00</h3>
                              <h3>TKD 2: 5:00</h3>
                              <h3>TKD 3: 6:00</h3>
                              <h4>Dec. 10th - March 11th</h4>
                              <h4 class="red">No Class 12/24,12/31,2/18</h4>
                              <h4>Class ends 3/4</h4>
                              <v-btn :disabled="false" color="primary" to="/signup/wed">Signup</v-btn>
                            </v-flex>
                            <v-flex xs12 sm4 pa-1>
                              <h2><u>Thursdays</u><v-icon color="red" >mdi-star</v-icon></h2>
                              <h3>TKD 1 & 2: 5:00</h3>
                              <h3>TKD 3: 6:00</h3>
                              <h3 style="opacity:0.0">TKD</h3>
                              <h4>Dec. 11th - March 12th</h4>
                              <h4 class="red">No Class 12/25,1/1,2/19</h4>
                              <h4>Class ends 3/5</h4>

                              <v-btn color="primary" to="/signup/thur">Signup</v-btn>
                            </v-flex>
                      </v-layout>

                      <h3 class="mt-3">$325 for the 10 week session. Payment due at time of registration. </h3>
                      <h3>Age Groups: TKD 1: 3-6 TKD 2: 7-11 TKD 3: 12 - Adult</h3>
                      <h3><v-icon color="red" >mdi-star</v-icon>New Location! All Classes will be held at TILT Crossfit 60 Union Ave. Sudbury</h3>
                      <h3><a href="https://maps.app.goo.gl/VzKbDnBTE7H9QAR69">Directions</a></h3>
                    </v-flex> -->





                  <!-- Summer -->
                    <!-- <mainHeader
                      title="Summer Taekwon-Do Session"
                      subtitle="6 week session starts 7/20"
                      class="mb-4">
                    </mainHeader>
                    <v-flex xs12>
                      <v-img
                        height="300px"
                        contain
                        :src="require('../assets/summer class.png')"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12>

                      <h3 class="mx-5 my-2">
                        This summer each week has a fun theme for the class. Students who attend the full session get the best experience by building skills week by week, gaining confidence, and enjoying everything our summer curriculum has to offer.
                      </h3>
                      <h3 class="mx-5 my-2">
                        I know summer schedules can be busy! Families are welcome to attend around vacations and commitments.  Every class is designed to be fun, engaging, and valuable on its own.
                      </h3>

                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <h3>
                            TKD 1 & 2
                          </h3>
                          <ul >
                            <li style="font-size:16px">Week 1: Ninja Training</li>
                            <li style="font-size:16px">Week 2: Island Survival</li>
                            <li style="font-size:16px">Week 3: Superhero Academy</li>
                            <li style="font-size:16px">Week 4: Video Game Level Up</li>
                            <li style="font-size:16px">Week 5: Pirates in Training</li>
                            <li style="font-size:16px">Week 6: Olympic Games</li>
                            </ul>
                        </v-flex>
                        <v-flex xs12 sm6>
                        <h3>
                          TKD 3
                        </h3>
                          <li style="font-size:16px">Week 1: Combinations: Mastery and Flow</li>
                          <li style="font-size:16px">Week 2: Advanced Sparring Strategy</li>
                          <li style="font-size:16px">Week 3: Power, Timing and Breaking</li>
                          <li style="font-size:16px">Week 4: Hos Sin Sol ( self defence)</li>
                          <li style="font-size:16px">Week 5: Patterns: Precision and Performance</li>
                          <li style="font-size:16px">Week 6: Endurance, Grit and Mental Toughness</li>
                        </v-flex>
                      </v-layout>


                    </v-flex>

                    <v-flex xs12 class="text-xs-center mb-5">
                      <v-layout row wrap>
                          <v-flex xs12 sm6 pa-2>
                            <h2><u>Mondays</u></h2>
                            <h3>TKD 1: 4:00</h3>
                            <h3>TKD 2: 5:00 </h3>
                            <h3>TKD 3: 6:00 </h3>
                            <h4>July 20th - August 24th</h4>

                            <v-btn color="primary" to="/signup/mon">Signup</v-btn>
                          </v-flex>



                          <v-flex xs12 sm4 pa-2>
                            <h2><u>Thursdays</u><v-icon color="red" >mdi-star</v-icon></h2>
                            <h3>TKD 1 & 2: 5:00</h3>
                            <h3>TKD 3: 6:00</h3>

                            <h4>Jul. 23rd - Aug. 27th</h4>

                            <v-btn color="primary" to="/signup/thur">Signup</v-btn>
                          </v-flex>


                      </v-layout>

                      <h3 class="mt-3">$195 for the 6 week session. Payment due at time of registration. </h3>
                      <h3>Age Groups: TKD 1: 3-5 TKD 2: 6-12 TKD 3: 13 & up</h3>

                    </v-flex>



 -->


          <!-- popup -->

                  <!-- <v-flex xs12 >
                    <v-img
                      height="200px"
                      contain
                      :src="require('../assets/winterwarrior.png')"
                    ></v-img>
                  </v-flex>
                  <mainHeader
                    class="mt-5"
                    title="Winter Warrior Tournament 2025"
                    subtitle="Saturday, December 6th at 11:30 AM">
                  </mainHeader>
                  <v-flex xs12 class="mb-5">
                    <h3 class="mt-2">  <v-icon>mdi-subdirectory-arrow-right</v-icon> Crossfit TILT, Sudbury</h3>
                    <h3>   <v-icon>mdi-subdirectory-arrow-right</v-icon> Patterns, Board Breaking, Jumping, and Sparring</h3>
                    <h3>   <v-icon>mdi-subdirectory-arrow-right</v-icon> Payment due at time of registration. Registration due by 11/25.</h3>
                    <v-flex xs3 offset-xs3>
                      <v-btn
                        large
                        color="primary"
                        class="mx-0"
                        to="/popup"
                      >Sign Up Now!</v-btn>
                    </v-flex>
                  </v-flex> -->


<!-- CAMP -->
<!--
                  <mainHeader
                    class="mt-5"
                    title="Kick It Up Summer Camp 2026"
                    subtitle="Registration opens January 1st, 2026">
                  </mainHeader>
                    <v-flex xs12 >
                      <v-img
                        height="300px"
                        contain
                        :src="require('../assets/camp1.jpg')"
                      ></v-img>
                    </v-flex>
                  <v-flex xs12 class="mb-5 text-xs-center">
                    <h3>July 20th - July 24th and August 3rd - August 7th</h3>
                    <h3>Wayside Inn, Sudbury</h3>
                    <h3>$100 Payment due at time of registration.</h3>
                    <v-flex xs12>
                      <v-btn
                        large
                        color="primary"
                        class="mx-0"
                        to="/camp"
                      >Sign Up Now!</v-btn>
                    </v-flex>

                        <h2 class="red">August Session is Full!</h2>
                        <h2 class="red">Email MissLisaTKD@gmail.com to signup for waitlist.</h2>
                  </v-flex> -->



          <!-- FALL -->
                  <mainHeader
                    title="Fall Taekwon-Do Session"
                    subtitle="10 week session starts 9/14"
                    class="mb-4">
                  </mainHeader>

                  <v-flex xs12>
                    <v-img
                      height="300px"
                      contain

                      :src="require('../assets/Main.jpg')"
                    ></v-img>
                  </v-flex>
                  <v-flex xs12 sm10 offset-sm1 class="text-xs-center mb-5">
                    <v-layout row wrap>
                        <v-flex xs12 sm3 pa-1>
                          <h2><u>Mondays</u></h2>
                          <h3>TKD 1: 4:00</h3>
                          <h3>TKD 2: 5:00</h3>
                          <h3>TKD 2&3: 6:00</h3>
                          <h3>Black Belt: 6:00 w/ Mr. Brandon</h3>
                          <h4>Sep. 14th - Dec. 7th</h4>
                          <!-- <h4 class="red">No Class 10/13</h4> -->
                          <v-btn color="primary" to="/signup/mon2">Signup</v-btn>
                        </v-flex>
                          <v-flex xs12 sm3 pa-1>
                            <h2><u>Tuesdays</u></h2>
                            <!-- <h3>TKD 1: 4:00</h3> -->
                            <h3 style="opacity:0.0">TKD</h3>
                            <h3>TKD 2: 5:00 w/ Mr. Sebastian</h3>
                            <!-- <h3>TKD 3 & Black Belt: 6:00</h3> -->
                            <h4>Sep. 15th - Dec. 8th</h4>
                            <!-- <h4 class="red">No Class 10/13</h4> -->
                            <v-btn color="primary" to="/signup/tue2">Signup</v-btn>
                          </v-flex>
                        <v-flex xs12 sm3 pa-1>
                          <h2><u>Wednesdays</u></h2>
                          <h3>TKD 1: 4:00</h3>
                          <h3>TKD 2: 5:00</h3>
                          <h3>TKD 3: 6:00</h3>
                          <h4>Sep. 16th - Dec. 9th</h4>
                          <!-- <h4 class="red">No Class 11/26</h4> -->
                          <v-btn :disabled="false" color="primary" to="/signup/wed2">Signup</v-btn>
                        </v-flex>
                        <v-flex xs12 sm3 pa-1>
                          <h2><u>Thursdays</u></h2>
                          <h3>TKD 1: 4:00</h3>
                          <h3>TKD 2: 5:00</h3>
                          <h3>TKD 3: 6:00</h3>
                          <!-- <h3 style="opacity:0.0">TKD</h3> -->
                          <h4>Sep. 17th - Dec. 10th</h4>
                          <!-- <h4 class="red">No Class 10/2 and 11/27</h4> -->
                          <v-btn color="primary" to="/signup/thur2">Signup</v-btn>
                        </v-flex>

                    </v-layout>
                    <h3 class="mt-3">$325 for the 10 week session. Payment due at time of registration. </h3>
                    <h3>Age Groups: TKD 1: 3-5 TKD 2: 6-12 TKD 3: 13 & up</h3>


                  </v-flex>


















                </v-layout>
              </v-flex>


<!-- Private Lessons -->
              <!-- <v-flex xs12 sm4 style="border-style: solid; border-color: #184f9f; border-radius: 5px; border-width: 5px;">
                <div class="mt-4 px-4">
                  <p style="" >
                   Private lessons are available online and in person. Contact me if you are interested.
                 </p>
                </div>
              </v-flex> -->




              <mainHeader
                title="Check out our classes in Brookline!"
                class="mt-4">
              </mainHeader>
              <v-flex xs12 class="mb-4">
                  <h3 class="mt-4">
                    <v-icon>mdi-subdirectory-arrow-right</v-icon>
                    <a href="https://app.amilia.com/store/en/town-of-brookline/api/Activity/Search?days=0&SelectedTags=&SelectedLocations=&SelectedAges=&SelectedProgram=&SelectedCategory=&SelectedSubCategory=&textCriteria=Tae+Kwon+Do&__RequestVerificationToken=CfDJ8HiOgHlYXzBJjWY6JQEhpdpoaRYfRmlDnohCXBZQI-YkelgteLZm2xiDO57tD4DJ-gU0_F4qj6Z7U8aKIwC4JQ0vMM53IdOebknh5bRmqJwljfqDK9KKrO4scw2eDGj1D5ZI0wlZmuxcSTzlC6wit_8">Brookline Recreation</a>
                  </h3>
              </v-flex>
              <v-flex class="mt-3">
                <p class="caption" >
                 <v-icon class="testimonialQuote">format_quote</v-icon>
                      The studio culture Lisa Hanson has built for these kids is a gift and we are grateful for it! They feel seen and empowered, and see that kindness and respect are worthy values. My son's fearlessness is being cherished and given focus, and it is so much fun to be part of!!! <br />- Joanna S.
                  <v-icon style="margin-top: -10px;">format_quote</v-icon>
                </p>
                <p class="caption" >
                  <v-icon class="testimonialQuote">format_quote</v-icon>
                  I love your philosophy of meeting each kid where they're at and boosting their confidence and skills from there. It's amazing to see where he is now from when we first started last spring. There are no words that quite describe the joy of seeing him blossom like that.  -EL
                  <v-icon style="margin-top: -10px;">format_quote</v-icon>
                </p>
              </v-flex>

            </v-layout>
            <h2 class="section-title">Taekwon-Do Birthday Parties</h2>
            <p>
                We offer Taekwon-Do birthday parties! You may choose between an in person outdoor party at your location or a live stream party. Email us at <a
                  target="_blank"
                  href="mailto:misslisatkd@gmail.com"
                >misslisatkd@gmail.com</a> for more information.
            </p>
          </v-flex>
          <v-flex xs12>
            <v-img
              :src="require('../assets/cupcakes.png')"
              class="elevation-10"
              max-height="400"
              max-width="400"
            ></v-img>
          </v-flex>


        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center fill-height class="pt-5">

      <v-flex xs12 sm6 lg4 class="pa-2">
        <v-img
          :src="require('../assets/new3.jpeg')"
          class="elevation-10 "
          max-height="400"
          max-width="400"
        ></v-img>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="pa-2">
        <v-img
          :src="require('../assets/new1.jpeg')"
          class="elevation-10 "
          max-height="400"
          max-width="400"
        ></v-img>
      </v-flex>
          <v-flex xs12 sm6 lg4 class="pa-2">

              <v-img
                :src="require('../assets/winterwarriorcollage.jpeg')"
                class="elevation-10 centeredPic"
                max-height="400"
                max-width="400"
              ></v-img>
          </v-flex>
      <v-flex xs12 sm6 lg4 class="pa-2">
        <v-img
          :src="require('../assets/new2.jpeg')"
          class="elevation-10 "
          max-height="400"
          max-width="400"
        ></v-img>
      </v-flex>

      <v-flex xs12 class="pa-2">
        <v-img
          :src="require('../assets/tenents.png')"
          class="elevation-10"
          max-height="400"
          max-width="700"
        ></v-img>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
  import Vuetify from 'vuetify'
  import mainHeader from '../components/header.vue'
  export default {
    data () {
      return {
        type: 'week',
        start: '2020-01-01',
        end: '2019-01-06'
      }
    },
    components: { mainHeader },
    computed: {
      vuetifyVersion () {
        return Vuetify.version
      },
      bottomPicStyle () {
        if (this.$vuetify.breakpoint.smAndUp) {
          return 'margin-top: -150px;'
        } else {
          return ''
        }
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.testimonialQuote {
  transform: rotate(180deg);
}
.v-image {
  margin: 0 auto
}
li {
  font-size: 24px;
}
h1 {
  font-size: 70px
}
</style>
<!-- <v-container fluid>
  <v-slide-y-transition mode="out-in">
    <v-layout column align-center>
      <h1>Viking Adaptive Martial Arts</h1>


      <blockquote>
        &#8220;Adaptive Martial Arts &#8221;
        <footer>
          <small>
            <em>&mdash;John Johnson</em>
          </small>
        </footer>
      </blockquote>
    </v-layout>
  </v-slide-y-transition>
</v-container> -->



// WEBPACK FOOTER //
// src/components/home.vue